import { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import { useImages } from "./useImages";
import { ReactComponent as Arrow } from 'assets/images/arro-left.svg'
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import style from './Images.module.scss'
const limiter = window.innerWidth <= 768 ? 16 : 42;

function Fancybox({ data, isOpen, index, closed }) {
    useEffect(()=> {
        if (data && isOpen) {
            const images = data.map(item => ({ src: item.path }))
            NativeFancybox.show([...images], {
                startIndex: index,
                on: {
                    close() {
                        closed()
                    }
                }
            })
        }
    })
    return null
}

export const Gallery = ()=> {
    const [limit, setLimit] = useState(limiter)
    const [isHidden, setIsHidden] = useState(false)
    const { t } = useTranslation()
    const { data } = useImages()
    const history = useHistory()
    const [imageIndex, setImageIndex] = useState(-1)
    useEffect(()=> {
        setIsHidden(limit >= data?.length)
    }, [limit, setIsHidden, data])

    const changeMore = ()=> {
        const updateLimit = limit + limiter
        setLimit(updateLimit)
    }

    const openImage = (index)=> ()=> {
        setImageIndex(index)
    }

    if (data?.length === 0) return history.push('/')

    if (!data) return null

    return (
        <div className={style.gallery}>
            <div className="container">
                <Link to="/" className={style.back}>
                    <Arrow />
                    {t('back')}
                </Link>
                <div className={style.box}>
                    <h2 className={style.title}>{t('images.title')}</h2>

                    <div className={style.grid}>
                        {data?.slice(0, limit).map((item, i) => (
                            <div key={item.id} className={style.grid_item} onClick={openImage(i)}>
                                <picture>
                                    <img src={item.path_thumb} alt="" width={221} height={130} loading="lazy" />
                                </picture>
                            </div>
                        ))}
                    </div>

                    <Fancybox
                        data={data}
                        isOpen={imageIndex !== -1}
                        index={imageIndex}
                        closed={openImage(-1)}
                    />
                    {!isHidden &&
                        <button onClick={changeMore} className={style.more}>{t('more')}<Arrow/></button>
                    }
                </div>
            </div>
        </div>
    )
}